import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';
import { ReportInstance, Report } from '../models';

@Injectable()
export class ReportRepositoryService extends BaseService<Report> {

  reportResourceRoute: string;

  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public setReportResourceRoute(reportResourceRoute: string | null): void {
    this.reportResourceRoute = reportResourceRoute;
  }

  public listReportInstances(reportId: number): Observable<ReportInstance[]> {
    return this.http.get<ReportInstance[]>(`${this.getResourceUrl()}${reportId}/instance`);
  }

  public getReportInstance(reportId: number, reportInstanceId: number): Observable<ReportInstance> {
    return this.http.get<ReportInstance>(`${this.getResourceUrl()}${reportId}/instance/${reportInstanceId}`);
  }

  public deleteReport(reportId: number): Observable<ReportInstance[]> {
    return this.http.delete<ReportInstance[]>(`${this.getResourceUrl()}${reportId}`);
  }

  public deleteReportInstance(reportId: number, reportInstanceId: number): Observable<ReportInstance[]> {
    return this.http.delete<ReportInstance[]>(`${this.getResourceUrl()}${reportId}/instance/${reportInstanceId}`);
  }

  public updateTitle(title: string, reportId: number): Observable<string> {
    return this.http.patch<string>(`${this.getResourceUrl()}${reportId}`, { title });
  }

  public updateFinalFlag(reportId: number, reportInstanceId: number, finalStatus: boolean, isActive: boolean): Observable<any> {
    return this.http.patch<any>(`${this.getResourceUrl()}${reportId}/instance/${reportInstanceId}`, { isFinal: finalStatus, isActive });
  }

  public unpublishReport(reportId: number, reportInstanceId: number): Observable<any> {
    return this.http.delete<any>(`${this.getResourceUrl()}${reportId}/instance/${reportInstanceId}/unpublish`);
  }

  public publishReport(reportId: number, reportInstanceId: number, containerId: number): Observable<any> {
    return this.http.post<any>(`${this.getResourceUrl()}${reportId}/instance/${reportInstanceId}/publish`, { containerId });
  }

  public updateRepostActiveStatus(reportId: number, reportInstanceId: number, containerId: number): Observable<any> {
    return this.http.patch<any>(`${this.getResourceUrl()}${reportId}/instance/${reportInstanceId}/active-status`, { containerId });
  }
  protected getResourceUrl(): string {
    return `${this.baseUrl}${this.reportResourceRoute}`;
  }

}
